<template>
  <div class="benefitEvents">
    <v-form>
      <v-row>
        <v-col cols="12">
          <v-btn depressed color="primary" :disabled="!showSidebar" @click="editBenefit(null)"
            >New Event</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="benefits"
            dense
            class="searchResults"
            @click:row="editBenefit"
            item-key="Id"
            :items-per-page="-1"
            :loading="loading"
            loading-text="Loading benefit events..."
            :single-select="true"
            :calculate-widths="true"
          >
            <template
              v-for="header in headers.filter((header) => header.format !== '')"
              v-slot:[`item.${header.value}`]="{ item, value }"
            >
              {{ formatTableEl(item, value, header.format) }}
            </template>
            <template v-slot:[`item.ProtectionReliedOn`]="{ item }">
              <v-simple-checkbox v-model="item.ProtectionReliedOn" disabled></v-simple-checkbox>
            </template>
            <template v-slot:[`item.ReportableEvent`]="{ item }">
              <v-simple-checkbox v-model="item.ReportableEvent" disabled></v-simple-checkbox>
            </template>
            <template v-slot:[`item.LTAExceeded`]="{ item }">
              <v-simple-checkbox v-model="item.LTAExceeded" disabled></v-simple-checkbox>
            </template>
            <template v-slot:[`item.Use5YearGuarantee`]="{ item }">
              <v-simple-checkbox v-model="item.Use5YearGuarantee" disabled></v-simple-checkbox>
            </template>
          </v-data-table>

          <Sidebar
            :isShown="isSidebarShown"
            :isNew="isNew"
            :formElements="formElements"
            :sidebarName="sidebarName"
            :isFormValid="isFormValid"
            @form-validity="isFormValid = $event"
            @delete="onDelete"
            @cancel="cancelChanges"
            @save="saveChanges"
          >
          </Sidebar>
        </v-col>
      </v-row>
    </v-form>
    <Dialog ref="confirmationDialog" />
  </div>
</template>

<script>
import Sidebar from '@/components/layout/Sidebar.vue';
import Utils from '@/utils.js';
import Dialog from '@/components/layout/Dialog.vue';

export default {
  components: { Sidebar, Dialog },
  name: 'BenefitEvents',

  data() {
    return {
      currentPlan: 0,
      loading: false,
      isSidebarShown: false,
      sidebarName: "benefit event",
      formElements: [],
      allElements: [],
      headers: [],
      benefits: [],
      selectedBenefit: null,
      isFormValid: false,
    };
  },

  computed: {
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    isNew() {
      if (this.selectedBenefit) return false;
      return true;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    showSidebar() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    memberId() {
      this.getBenefitEvents();
    },
  },

  created() {
    this.getHeaders();
  },

  mounted: function () {
    if (!this.memberId) {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    } else {
      this.getForm('BenefitEvents');
      this.$root.currentPage = 'BenefitEvents';
    }
  },

  methods: {
    formatTableEl(item, value, format) {
      return Utils.formatTableValue(value, format);
    },
    editBenefit(item) {
      if (!this.showSidebar) return;
      this.isSidebarShown = true;
      if (item) {
        this.getBenefitEvent(item.Id);
      } else {
        this.formElements.forEach((el) => (el.Value = ''));
        this.selectedBenefit = {};
        this.selectedBenefit.MembershipId = this.memberId;
        this.selectedBenefit.Id = 0;
      }
    },

    cancelChanges() {
      this.isSidebarShown = false;
      this.selectedBenefit = false;
    },

    saveChanges() {
      if (this.isFormValid) {
        this.isSidebarShown = false;
        this.updateBenefitEvent();
      }
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteBenefitEvent();
      } catch (err) {
        console.log(err);
      }
    },

    async updateBenefitEvent() {
      this.loading = true;
      try {
        this.formElements.forEach((el) => {
          this.selectedBenefit[el.FieldName] = el.Value;
        });
        await this.$api.post('/Benefit/UpdateBenefitEvent', this.selectedBenefit);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Benefit event was updated',
        });
        this.getBenefitEvents();
      } catch (err) {
        console.log(err.message);
      } finally {
        this.loading = false;
      }
    },

    async deleteBenefitEvent() {
      this.isSidebarShown = false;
      try {
        await this.$api.delete('/Benefit/DeleteBenefitEvent?Id=' + this.selectedBenefit.Id);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Benefit event was deleted',
        });
        this.getBenefitEvents();
      } catch (err) {
        console.log(err.message);
      }
    },

    async getBenefitEvents() {
      this.loading = true;
      try {
        let response = await this.$api.get(
          '/Benefit/GetBenefitEvents?membershipid=' + this.memberId
        );

        this.benefits = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async getBenefitEvent(id) {
      try {
        let response = await this.$api.get('/Benefit/GetBenefitEvent?eventId=' + id);

        if (!response.data) {
          const msg = 'Unable to get benefit event';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.selectedBenefit = response.data;
        var data = response.data;
        // match data with form fields
        if (data) Utils.setDataToFormElements(data, this.formElements);
      } catch (err) {
        console.error(err);
      }
    },

    async getForm(formName) {
      try {
        let response = await this.$api.get(
          '/datadictionary/GetFormElements?formName=' + formName + '&planId=' + this.currentPlanId
        );

        this.allElements = response.data;
        this.formElements = response.data.filter((f) => f.Visible == true);

        this.getBenefitEvents();
      } catch (err) {
        console.error(err);
      }
    },

    async getHeaders() {
      try {
        const response = await this.$api.get(
          `/datadictionary/GetGridHeaders?formName=BenefitEvents&planId=${this.currentPlanId}`
        );

        if (response.data.length) {
          const data = response.data.filter((item) => item.Visible);
          data.sort((a, b) => a.ColumbOrder - b.ColumbOrder);
          this.headers = data.map((item) => ({
            text: item.HeaderText,
            value: item.Datafield,
            align: item.Align.toLowerCase(),
            format: item.FieldFormat,
          }));
        }
      } catch (err) {
        console.log(err.message);
      }
    },
  },
};
</script>

<style scoped>
.benefitEvents {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;
}

.sidebar {
  margin-bottom: 30px;
}

.sidebar h3 {
  margin-bottom: 20px;
}

.btnsContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
